import { Component, Input } from '@angular/core';
import { ClientConsultNoteTask } from '../../../core/models/client-consult-note-task.model';
import { PrescriberIncorrectInformationPromptComponent } from '../../../shared/components/prescriber-incorrect-information-prompt/prescriber-incorrect-information-prompt.component';
import { PrescriberNameComponent } from '../../../shared/components/prescriber-name/prescriber-name.component';
import { PrescriberOfficesScrollableComponent } from '../../../shared/components/prescriber-offices-scrollable/prescriber-offices-scrollable.component';
import { ClientConsultNoteTaskReferralsComponent } from '../client-consult-note-task-referrals/client-consult-note-task-referrals.component';
import { ClientTaskEncountersComponent } from '../client-task-encounters/client-task-encounters.component';
import { ClientConsultNoteTaskRelatedTasksComponent } from '../client-consult-note-task-related-tasks/client-consult-note-task-related-tasks.component';
import { SpecialtyBadgesComponent } from '../../../shared/components/specialty-badges/specialty-badges.component';

@Component({
    selector: 'app-client-consult-note-task-details',
    templateUrl: './client-consult-note-task-details.component.html',
    styleUrls: ['./client-consult-note-task-details.component.scss'],
    imports: [PrescriberIncorrectInformationPromptComponent,
              PrescriberNameComponent,
              PrescriberOfficesScrollableComponent,
              ClientConsultNoteTaskReferralsComponent,
              ClientTaskEncountersComponent,
              ClientConsultNoteTaskRelatedTasksComponent,
              SpecialtyBadgesComponent]
})
export class ClientConsultNoteTaskDetailsComponent {
  @Input() task: ClientConsultNoteTask;
}
